import { render, staticRenderFns } from "./TaskManagments.vue?vue&type=template&id=2be0ee87"
import script from "./TaskManagments.vue?vue&type=script&lang=js"
export * from "./TaskManagments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports